import React from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import FullModal from '../../modals/full'
import useApiMutation from '../../../hooks/use-api-mutation'
import useToasts from '../../../hooks/use-toasts'
import useUserGoals from '../../../hooks/use-user-goals'
import Spinner from '../../common/spinner-container'
import DimensionsSelector from '../../dimensions/tagged-selector'
import { get } from 'lodash'
import useUserGoalMutations from '../../../hooks/use-user-goal-mutations'

const GoalEditForm = ({
    userId,
    goalId,
    onComplete = () => {},
}) => {

    const {
        success: toastSuccess,
        error: toastError
    } = useToasts({
        successMessage: `Goal ${goalId ? 'updated' : 'created' } successfully!`,
        errorMessage: `Error ${goalId ? 'updating' : 'creating' } goal.`,
        onSuccess: onComplete,
    })

    const {
        userGoal,
        setUserGoal,
        isLoading,
        isSaving,
        saveUserGoal,
    } = useUserGoalMutations({
        userId,
        goalId,
        onSuccess: toastSuccess,
        onError: toastError,
    })

    if (isLoading ) {
        return (<Spinner label='Loading goal...' />)
    }

    if (isSaving ) {
        return (<Spinner label='Saving goal...' />)
    }

    return (
        <div style={{ padding: '20px', marginTop: '20px'}}>
            <Form.Group>
                <Form.Label>GOAL</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter goal title"
                    value={get(userGoal, 'title', '')}
                    onChange={e => setUserGoal({ ...userGoal, title: e.target.value })}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>DIMENSIONS</Form.Label>
                <DimensionsSelector
                    value={get(userGoal, 'dimensions', '')}
                    onChange={dimensions => setUserGoal({ ...userGoal, dimensions })}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>DETAILS</Form.Label>
                <Form.Control as="textarea" rows={5}
                    placeholder="Enter goal details here"
                    value={get(userGoal, 'content') || ''}
                    onChange={e => setUserGoal({ ...userGoal, content: e.target.value })}
                />
            </Form.Group>
            <Row>
                <Col>
                    <Button block onClick={() => saveUserGoal()}>{goalId ? 'UPDATE' : 'CREATE'} GOAL</Button>
                </Col>
            </Row>
        </div>
    )
}

export default GoalEditForm